import PropTypes from "prop-types";
import React from "react";
import { registerComponent } from "@/components/DynamicComponent";
import { QuerySourceTypeIcon } from "@/components/queries/QuerySourceTypeIcon";
import { useTheme } from "@/components/ThemeProvider";

import "./QuerySourceDropdownItem.less";

export function QuerySourceDropdownItem({ dataSource, children }) {
  const { isDarkMode } = useTheme();

  return (
    <div className={`query-source-dropdown-item ${isDarkMode ? 'dark-mode' : ''}`}>
      <QuerySourceTypeIcon type={dataSource.type} aria-label={dataSource.name} title={dataSource.name} />
      {children ? children : <span>{dataSource.name}</span>}
    </div>
  );
}

QuerySourceDropdownItem.propTypes = {
  dataSource: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
  }).isRequired,
  children: PropTypes.element,
};

registerComponent("QuerySourceDropdownItem", QuerySourceDropdownItem);
